import { Button } from "@zendeskgarden/react-buttons";
import { Body, Close, Footer, FooterItem, Header, Modal } from "@zendeskgarden/react-modals";
import { ReactElement } from "react";
import { Inline } from "@zendeskgarden/react-loaders";

export interface IBudgetYearProtectingModal {
    budgetSeason: string,
    targetProtectionState: boolean,
    loading: boolean,
    onClose: () => void,
    onConfirm: () => void,
}

export default function BudgetYearProtectionModal(props: IBudgetYearProtectingModal): ReactElement {

    return (
        <Modal onClose={props.onClose}>
            <Header isDanger>
                Confirm {props.targetProtectionState ? "lock" : "unlock"} of Budget Season
            </Header>
            <Body>
                Are you sure you want to {props.targetProtectionState ? "lock" : "unlock"} the {props.budgetSeason} Budget Season?
                {
                    props.targetProtectionState ?
                    "Locked budget season is not allowed to have modelling configuration to be copied over to"
                    :
                    "Unlocked budget season allows to copy over modelling methods to. Any such copy operation removes any existing configuration."
                }
            </Body>
            <Footer>
                <FooterItem>
                    <Button onClick={props.onClose} isBasic disabled={props.loading}>
                        Cancel
                    </Button>
                </FooterItem>
                <FooterItem>
                    {
                        <Button isPrimary onClick={props.onConfirm} disabled={props.loading}>
                            {
                                props.loading
                                    ? <Inline size={24} aria-label="loading"/>
                                    : <span>Confirm</span>
                            }
                        </Button>
                    }
                </FooterItem>
            </Footer>
            <Close aria-label="Close modal" />
        </Modal>
    );
}